import React, { useState } from "react";
import "./Contact.scss";
import { contacts } from "../../../Data";
import { socialIcons } from "../../../Data";
import { motion } from "framer-motion";
import axios from "axios";

import toast, { Toaster } from "react-hot-toast";

const Contact = () => {
  let initialData = {
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    message: "",
  };
  const [data, setData] = useState(initialData);

  const inputHandler = (evt) => {
    const value = evt.target.value;
    setData({
      ...data,
      [evt.target.name]: value,
    });
  };

  const clearDataFunc = () => {
    setData(initialData);
  };

  const submit = async () => {
    const bodyData = data;

    await axios
      .post(
        "https://sheetdb.io/api/v1/zdimd82j5c7ct",
        bodyData
      )
      .then((data) => {
        if (data.status === 200) {
          toast.success("Form submitted successfully!");
          clearDataFunc();
        } else {
          toast.error("Error in submitting form");
          clearDataFunc();
        }
      })
      .catch((e) => {
        toast.error("Error in submitting form");
        clearDataFunc();
      });
  };
  return (
    <div className="container" id="contact">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title"
      >
        <span>get in touch</span>
        <h1>Contact Me</h1>
      </motion.div>
      <div className="contact_form">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [150, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="contact_right"
        >
          <h3>Get In Touch</h3>

          <div className="row">
            <input
              type="text"
              name="firstName"
              value={data.firstName}
              onChange={(e) => inputHandler(e)}
              placeholder="First Name"
            />
            <input
              type="text"
              name="lastName"
              value={data.lastName}
              onChange={(e) => inputHandler(e)}
              placeholder="Last name"
            />
          </div>
          <div className="row">
            <input
              type="text"
              name="contact"
              value={data.contact}
              onChange={(e) => inputHandler(e)}
              placeholder="Phone"
            />
            <input
              type="email"
              name="email"
              value={data.email}
              onChange={(e) => inputHandler(e)}
              placeholder="Email"
            />
          </div>
          <div className="row">
            <textarea
              name="message"
              value={data.message}
              onChange={(e) => inputHandler(e)}
              placeholder="message"
            ></textarea>
          </div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
            className="btn"
            onClick={(e) => submit(e)}
          >
            <button
              style={{
                background: "transparent",
                border: "none",
                color: "white",
              }}
            >
              Send
            </button>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
